import React from 'react'

type Props = { children: React.ReactNode | React.ReactNode[], label?: string }
const FormGroup: React.FC<Props> = ({ children, label }) => {
  return (
    <div className='flex flex-col my-6'>
      {label && <label className='mb-4 text-center text-xs sm:text-sm'><strong>{label}</strong></label>}
      {children}
    </div>
  )
}

export default FormGroup
